import { requireStates } from "util";
import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);

const initialStates = [
  {
    name: "app.history.sales",
    url: "/historico-de-vendas",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        priority: 200,
        name: "Histórico de Vendas",
        state: "app.history.sales"
      },
      authorization: context =>
        context.user.permissions.includes("view_closed_sales") ||
        context.user.permissions.includes("view_cash_register_sales")
    }
  }
];

const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/history/sales/index.js